import React from 'react';
import { cn } from '../cn.js';

const variantClass = {
    default:
        'bg-pink-accent text-green-accent border-0 hover:enabled:bg-pink-hover active:enabled:bg-dirty-pink active:enabled:text-white',
    outline:
        'bg-white text-green-accent border-2 border-solid border-pink-accent hover:enabled:bg-pink-hover',
    ghost: 'bg-transparent text-green-accent border-0',
};

const sizeClass = {
    small: 'h-40 px-20 py-8 w-max font-montserrat text-m',
    medium: 'h-[46px] px-28 py-12 w-max font-montserrat-medium text-l',
    large: 'h-[46px] px-28 py-12 w-max font-montserrat-medium text-l',
};

/**
 * Design-system button.
 * @param {'default'|'outline'|'ghost'} [variant]
 * @param {'small'|'medium'|'large'} [size]
 */
const Button = ({
    children,
    content,
    variant = 'default',
    size = 'medium',
    disabled = false,
    type = 'button',
    className = '',
    onClick,
    ...rest
}) => (
    <button
        type={type}
        disabled={disabled}
        onClick={onClick}
        className={cn(
            'block__button button inline-flex box-border cursor-pointer items-center justify-center rounded-button',
            size && `button_${size}`,
            variant === 'outline' && 'button_outline',
            variant === 'ghost' && 'button_ghost',
            disabled && 'button_disabled',
            variantClass[variant] ?? variantClass.default,
            sizeClass[size] ?? sizeClass.medium,
            'disabled:pointer-events-none disabled:cursor-default disabled:bg-disabled disabled:text-light-grey',
            className,
        )}
        {...rest}
    >
        <span className="button__content inline-flex items-center first-letter:uppercase">
            {content ?? children}
        </span>
    </button>
);

export default Button;
